import mitt from 'mitt';

let emitter = mitt();
let chunkNumberForSEEEvent = 0;
let chunkNumberStruct = {};

function resetEmitter() {
  emitter.all.clear();
  emitter = mitt();
}
function emitEvent(event, data) {
  emitter.emit(event, data);
}

function getChunkNumberForSSEEvent(id) {
  return chunkNumberStruct[id]?.num || 0;
}

function setChunkNumberForSEEEvent(chunkNumber, id, data) {
  chunkNumberForSEEEvent = chunkNumber;
  if (chunkNumberStruct[id]) {
    chunkNumberStruct[id].num = chunkNumber;
    chunkNumberStruct[id].data = data;
  } else {
    chunkNumberStruct[id] = {};
    chunkNumberStruct[id].num = chunkNumber;
    chunkNumberStruct[id].data = data;
  }
}
export {
  emitter,
  resetEmitter,
  emitEvent,
  chunkNumberForSEEEvent,
  setChunkNumberForSEEEvent,
  getChunkNumberForSSEEvent,
};
